module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_9005.de37d805.png";